import React, { useState, useEffect } from 'react';
import { Spin, Alert, Button } from 'antd';
import { useKeycloak } from '@react-keycloak/web';
import { getAllWorkflowMarketplaceComponents } from '../../services/dsl_DataService.js';
import MarketplaceItemCard from '../../components/marketplace/MarketplaceItemCard';
import '../../components/marketplace/Marketplace.css';

function WorkflowIntroductionComponent() {
  const { keycloak, initialized } = useKeycloak();
  const [workflowComponents, setWorkflowComponents] = useState([]);
  const [isLoadingApi, setIsLoadingApi] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchWorkflowData = async () => {
      if (!initialized || !keycloak.authenticated || !keycloak.token) {
        setIsLoadingApi(false);
        if (initialized && !keycloak.authenticated) {
          setError(new Error('You are not authenticated. Please log in to view components.'));
        } else {
          setError(new Error('Authentication status unclear or token not available.'));
        }
        return;
      }

      try {
        setIsLoadingApi(true);
        setError(null);
        const data = await getAllWorkflowMarketplaceComponents(keycloak.token);
        setWorkflowComponents(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error('Failed to fetch marketplace components:', err);
        setError(new Error(`Failed to load components: ${err.message || 'Unknown error. Please try again.'}`));
      } finally {
        setIsLoadingApi(false);
      }
    };

    fetchWorkflowData();
  }, [keycloak.token, keycloak.authenticated, initialized]);

  if (!initialized || isLoadingApi) {
    return (
      <div style={{ padding: '50px', textAlign: 'center' }}>
        <Spin size='large' tip={!initialized ? 'Initializing authentication...' : 'Loading marketplace...'} />
      </div>
    );
  }

  if (error) {
    const isAuthError = error.message.includes('not authenticated');
    return (
      <div style={{ padding: '20px' }}>
        <Alert
          message={isAuthError ? 'Authentication Required' : 'Error Loading Data'}
          description={error.message}
          type='error'
          showIcon
          action={
            isAuthError &&
            keycloak && (
              <Button type='primary' onClick={() => keycloak.login()}>
                Log In
              </Button>
            )
          }
        />
      </div>
    );
  }

  if (!keycloak.authenticated) {
    return (
      <div style={{ padding: '20px' }}>
        <Alert
          message='Access Denied'
          description='You are not authorized to view this content. Please log in.'
          type='warning'
          showIcon
          action={
            <Button type='primary' onClick={() => keycloak.login()}>
              Log In
            </Button>
          }
        />
      </div>
    );
  }

  if (workflowComponents.length === 0) {
    return (
      <Alert
        message='No Components Found'
        description='There are no workflow components available at this time.'
        type='info'
        showIcon
      />
    );
  }

  return (
    <div className='marketplace-grid'>
      {workflowComponents.map((component) => (
        <MarketplaceItemCard key={component.id} component={component} />
      ))}
    </div>
  );
}

export default WorkflowIntroductionComponent;
